import React, { useEffect, useState } from "react";
import {
  ShareAltOutlined,
  PlusSquareOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Button } from "antd";


import { SafariShareIcon } from "../css/svg/safariShareIcon";


const INSTALL_PROMPT_KEY = "streenStudioInstallPromptDismissed";
const INSTALL_PROMPT_NEVER_SHOW_KEY = "streenStudioInstallPromptNeverShow";

const IpadInstallPrompt = () => {
  const [visible, setVisible] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const isIpad =
      /iPad/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1);

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      navigator.standalone === true;

    const hasDismissed =
      sessionStorage.getItem(INSTALL_PROMPT_KEY) === "true";

    const shouldNeverShow =
      localStorage.getItem(INSTALL_PROMPT_NEVER_SHOW_KEY) === "true";

    if (
      isIpad &&
      !isStandalone &&
      !hasDismissed &&
      !shouldNeverShow
    ) {
      setVisible(true);
    }
  }, []);

  const dismissPrompt = () => {
    if (dontShowAgain) {
      localStorage.setItem(INSTALL_PROMPT_NEVER_SHOW_KEY, "true");
    } else {
      // Hide for the rest of the current browser session.
      sessionStorage.setItem(INSTALL_PROMPT_KEY, "true");
    }

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside
      className="ipad-install-prompt"
      aria-label="STREEN-Studio installieren"
    >
      <button
        type="button"
        className="ipad-install-close"
        onClick={dismissPrompt}
        aria-label="Hinweis schließen"
      >
        <CloseOutlined />
      </button>

      <div className="ipad-install-heading">
        <ShareAltOutlined />
        <strong>STREEN-Studio installieren</strong>
      </div>

      <p className="install-intro">
        Füge STREEN-Studio zu deinem Home-Bildschirm hinzu,
        um die App schnell zu öffnen.
      </p>

      <div className="install-step">
        <SafariShareIcon className="install-step-icon" />
        <div>
          <strong>1. Tippe auf „Teilen“</strong>
          <p>Öffne das Teilen-Menü in Safari.</p>
        </div>
      </div>

      <div className="install-step">
        <PlusSquareOutlined className="install-step-icon" />
        <div>
          <strong>2. Wähle „Zum Home-Bildschirm“</strong>
          <p>Scrolle im Menü gegebenenfalls nach unten.</p>
        </div>
      </div>

      <div className="install-step">
        <CheckOutlined className="install-step-icon" />
        <div>
          <strong>3. Tippe auf „Hinzufügen“</strong>
          <p>Das Symbol erscheint auf deinem Home-Bildschirm.</p>
        </div>
      </div>

      <label className="install-never-show">
        <input
          type="checkbox"
          checked={dontShowAgain}
          onChange={(event) => setDontShowAgain(event.target.checked)}
        />
        Nicht mehr anzeigen
      </label>

     <Button
                      type="primary"
        onClick={dismissPrompt}
      >
        Alles klar!
      </Button>
    </aside>
  );
};

export default IpadInstallPrompt;